import React from "react";
import DeleteGif from "images/Hotstar/deleted.gif";

import { Box, Typography } from "@material-ui/core";
import Popup from "reactjs-popup";

export default function DeletedPopup({ opener, onClose, text }) {
  React.useEffect(() => {
    if (opener) {
      setTimeout(() => {
        onClose();
      }, 4000);
    }
  }, [opener]);
  return (
    <Popup
      open={opener}
      closeOnDocumentClick
      closeOnEscape
      onClose={onClose}
      position="center center"
      modal
      nested
      contentStyle={{
        background: "white",
        width: "358px",
      }}
      overlayStyle={{ background: "rgba(51, 51, 51, 0.45)" }}
    >
      <Box style={{ padding: "1.3rem 2rem", textAlign: "center" }}>
        <ReloadableDeletedGif />
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "400",
            color: "#2F80ED",
            fontFamily: `'Inter',sans-serif`,
            lineHeight: "29px",
          }}
        >
          {text}
        </Typography>
      </Box>
    </Popup>
  );
}

class ReloadableDeletedGif extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gif: DeleteGif,
      loaded: DeleteGif,
    };
  }

  componentDidMount() {
    this.reloadGif();
  }

  reloadGif = () => {
    this.setState({ loaded: "" });
    setTimeout(() => {
      this.setState({ loaded: this.state.gif });
    }, 0);
  };

  render() {
    return (
      <img src={this.state.loaded} style={{ width: "70%" }} alt="Deleted" />
    );
  }
}
